import { OLoader } from '@src/shared';

type TPageControllerProps = {
  isLoading: boolean;
  condition: boolean;
  ComponentA: JSX.Element;
  ComponentB: JSX.Element;
};

const PageController = ({ isLoading, condition, ComponentA, ComponentB }: TPageControllerProps) => {
  if (isLoading) {
    return <OLoader />;
  }

  return condition ? ComponentB : ComponentA;
};

export default PageController;
